import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, map, take, of } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { environment } from '../../environments/environment';
import { LoggingService } from '@fleet-monitor/frontend-logging';

export const authGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggingService);

  // E2E test bypass: if localStorage flag is set, allow navigation
  // Security note: This is only for E2E testing purposes. While a malicious
  // user could exploit this in a production environment, it does not pose
  // a risk to real user data or operations, as the API enforces
  // proper authentication and authorization.
  try {
    if (
      !environment.production &&
      typeof window !== 'undefined' &&
      window.localStorage.getItem('E2E_TEST_AUTH') === '1'
    ) {
      return of(true);
    }
  } catch (error) {
    logger.warn('[authGuard] Unable to read E2E bypass flag', error);
  }

  return combineLatest([
    authService.isLoading$,
    authService.isAuthenticated$,
  ]).pipe(
    // Wait until the SDK finishes processing the redirect
    filter(([loading]) => !loading),
    take(1),
    map(([_, isAuthenticated]) => {
      if (isAuthenticated) {
        return true;
      }
      router.navigate(['/login']);
      return false;
    })
  );
};
